import { useState } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// Answer boxes (grammar lessons, Sea Snake) don't take pasted or dropped text:
// the answer has to be typed. Blocked tries show a short "type it yourself".
// ─────────────────────────────────────────────────────────────────────────────

/** Props for an answer <input>, and whether to show the "no pasting" note right now. */
export function useNoPaste() {
  const [warned, setWarned] = useState(false);
  const block = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setWarned(true);
    window.setTimeout(() => setWarned(false), 2500);
  };
  return {
    warned,
    props: {
      onPaste: block,
      onDrop: block,
      autoComplete: 'off',
      // Some phone keyboards paste through "input" with this type instead of a paste event.
      onBeforeInput: (e: React.FormEvent<HTMLInputElement>) => {
        const t = (e.nativeEvent as InputEvent).inputType;
        if (t === 'insertFromPaste' || t === 'insertFromDrop' || t === 'insertFromPasteAsQuotation') block(e);
      },
    },
  };
}
